import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MinimalTableHeaderCell } from "src/ui/shared/table/MinimalTableComponents";
import { TableHeader } from "src/ui/shared/table/TableHeader";
import { makeStyles } from "tss-react/mui";

import { useGroupsAndWorkspaceMembers } from "@dashboard/groups/store/helpers";
import { Paper, Table, TableBody, TableContainer, TableRow } from "@mui/material";
import { SectionPanel } from "@shared/SectionPanel/SectionPanel";
import CustomTablePagination from "@shared/table/TablePagination";

import { MemberListItem } from "./MemberListItem/MemberListItem";

const useStyles = makeStyles()(() => ({
    table: {
        boxShadow: "none",
        flex: 1,
        minHeight: 0,
    },
    pagination: {
        flexShrink: 0,
    },
}));

export const MembersTable = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { t } = useTranslation(["common", "pages"]);
    const { classes } = useStyles();
    const allMembers = useGroupsAndWorkspaceMembers();

    const maxPage = Math.max(0, Math.ceil(allMembers.length / rowsPerPage) - 1);
    const currentPage = Math.min(page, maxPage);
    const pagedMembers = allMembers.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);

    return (
        <SectionPanel title={t("pages:workspacePage.section.title.members")}>
            <TableContainer component={Paper} className={classes.table}>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <MinimalTableHeaderCell align="left"></MinimalTableHeaderCell>
                            <MinimalTableHeaderCell align="left">{t("common:label.email")}</MinimalTableHeaderCell>
                            <MinimalTableHeaderCell align="left">{t("common:label.role")}</MinimalTableHeaderCell>
                            <MinimalTableHeaderCell></MinimalTableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {pagedMembers.map((member, index) => (
                            <MemberListItem key={member.id} index={currentPage * rowsPerPage + index} member={member} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <CustomTablePagination
                component="div"
                className={classes.pagination}
                rowsPerPageOptions={[10, 25, 50]}
                count={allMembers.length}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={(_event, nextPage) => setPage(nextPage)}
                onRowsPerPageChange={(event) => {
                    setRowsPerPage(Number(event.target.value));
                    setPage(0);
                }}
            />
        </SectionPanel>
    );
};
